
import http from "../util/http";

const modules = `at`;

const modulesCt = "ct";

export default {
  getCode: data => http.getCode(`sy/setting/captcha`, data), // 获取验证码
  getKaptcha: data => http.getCode(`ct/document/kaptcha`, data), // 获取验证码
  documentList: data => http.get(`ct/document/list`, data), //信息
  coaList: data => http.post(`ct/document/coaList`, data), //coa信息
  msdsList: data => http.post(`ct/document/msdsList`, data), //msds信息
  safetyList: data => http.post(`ct/document/safetyList`, data), //safety信息
  tdsList: data => http.post(`ct/document/tdsList`, data), //tds信息

  // 获取公众号秘钥
  getJssdkSignData: data => http.get(`common/wechat/getJssdkSignData`, data), //获取公众号秘钥
};